<template>
  <div>
    <h4>{{ $t('permit-value-by-building-type') }}</h4>
    <div class="table-responsive">
      <table class="table table-striped table-bordered">
      <thead>
        <tr>
          <th scope="col" rowspan="2">{{ $t('building-type') }}</th>
          <th scope="col" colspan="6">{{ $t('year-to-date') }}, {{ $t('value-in-thousands').toLowerCase() }}</th>
        </tr>
        <tr>
          <th scope="col">{{ $t('city-centre') }}</th>
          <th scope="col">{{ $t('assiniboia') }}</th>
          <th scope="col">{{ $t('lord-selkirk') }}</th>
          <th scope="col">{{ $t('east-kildonan') }}</th>
          <th scope="col">{{ $t('riel') }}</th>
          <th scope="col">{{ $t('total-city') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="row"><h5 class="mb-0">{{ $t('residential') }}</h5></th>
          <td colspan="6" />
        </tr>
        <tr v-for="(res, i) in residentials" :key="i + 'res'">
          <td scope="row">{{ res.building_type }}</td>
          <td>
            {{ res.city_center_value | currency($LANG) }}
          </td>
          <td>
            {{ res.assiniboia_value | currency($LANG) }}
          </td>
          <td>
            {{ res.west_kildonan_value | currency($LANG) }}
          </td>
          <td>
            {{ res.east_kildonan_value | currency($LANG) }}
          </td>
          <td>{{ res.riel_value | currency($LANG) }}</td>
          <td>{{ res.total_value | currency($LANG) }}</td>
        </tr>
        <tr>
          <th scope="row">{{ $t('total-residential') }}</th>
          <td>
            {{ totalRes.city_center_value | currency($LANG) }}
          </td>
          <td>
            {{ totalRes.assiniboia_value | currency($LANG) }}
          </td>
          <td>
            {{ totalRes.west_kildonan_value | currency($LANG) }}
          </td>
          <td>
            {{ totalRes.east_kildonan_value | currency($LANG) }}
          </td>
          <td>
            {{ totalRes.riel_value | currency($LANG) }}
          </td>
          <td>
            {{ totalRes.total_value | currency($LANG) }}
          </td>
        </tr>
        <tr>
          <th scope="row"><h5 class="mb-0">{{ $t('non-residential') }}</h5></th>
          <td colspan="6" />
        </tr>
        <tr v-for="(res, i) in nonResidentials" :key="i + 'nonres'">
          <td scope="row">{{ res.building_type }}</td>
          <td>
            {{ res.city_center_value | currency($LANG) }}
          </td>
          <td>
            {{ res.assiniboia_value | currency($LANG) }}
          </td>
          <td>
            {{ res.west_kildonan_value | currency($LANG) }}
          </td>
          <td>
            {{ res.east_kildonan_value | currency($LANG) }}
          </td>
          <td>{{ res.riel_value | currency($LANG) }}</td>
          <td>{{ res.total_value | currency($LANG) }}</td>
        </tr>
        <tr>
          <th scope="row">{{ $t('total-non-residential') }}</th>
          <td>
            {{ totalNonRes.city_center_value | currency($LANG) }}
          </td>
          <td>
            {{ totalNonRes.assiniboia_value | currency($LANG) }}
          </td>
          <td>
            {{ totalNonRes.west_kildonan_value | currency($LANG) }}
          </td>
          <td>
            {{ totalNonRes.east_kildonan_value | currency($LANG) }}
          </td>
          <td>
            {{ totalNonRes.riel_value | currency($LANG) }}
          </td>
          <td>
            {{ totalNonRes.total_value | currency($LANG) }}
          </td>
        </tr>
        <tr>
          <th scope="row">{{ $t('total') }}</th>
          <td>
            {{ total.curr_city_center_value | currency($LANG) }}
          </td>
          <td>
            {{ total.curr_assiniboia_value | currency($LANG) }}
          </td>
          <td>
            {{ total.curr_west_kildonan_value | currency($LANG) }}
          </td>
          <td>
            {{ total.curr_east_kildonan_value | currency($LANG) }}
          </td>
          <td>
            {{ total.curr_riel_value | currency($LANG) }}
          </td>
          <td>
            {{ total.curr_total_value | currency($LANG) }}
          </td>
        </tr>
        <tr>
          <th scope="row">
            {{ $t('total') }}, {{ lastYear }}
          </th>
          <td>
            {{ total.prev_city_center_value | currency($LANG) }}
          </td>
          <td>
            {{ total.prev_assiniboia_value | currency($LANG) }}
          </td>
          <td>
            {{ total.prev_west_kildonan_value | currency($LANG) }}
          </td>
          <td>
            {{ total.prev_east_kildonan_value | currency($LANG) }}
          </td>
          <td>
            {{ total.prev_riel_value | currency($LANG) }}
          </td>
          <td>
            {{ total.prev_total_value | currency($LANG) }}
          </td>
        </tr>
        <tr>
          <th scope="row">{{ $t('change') }}</th>
          <td>{{ total.city_centre_change_pct | percent($LANG) }}</td>
          <td>{{ total.assiniboia_change_pct | percent($LANG) }}</td>
          <td>{{ total.west_kildonan_change_pct | percent($LANG) }}</td>
          <td>{{ total.east_kildonan_change_pct | percent($LANG) }}</td>
          <td>{{ total.riel_change_pct | percent($LANG) }}</td>
          <td>{{ total.total_change_pct | percent($LANG) }}</td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "ActivityTable2",
  props: {
    curYear: String,
    startDate: String,
    endDate: String,
  },

  data() {
    return {
      response06: [],
      response07: [],
      response08: [],
    }
  },

  created() {
    this.fetchData();
  },

  watch: {
    endDate() {
      this.fetchData();
    }
  },

  methods: {
    fetchData() {
      const startDate = this.startDate;
      const endDate = this.endDate;
      // Permit Value by Buiding Type and Community
      // By Building Type
      const request06 = axios.get(
        `${this.$PERMIT_API}?$select=residential_category, building_type, sum(case(community='City Centre',declared_construction_value,true,0)) as city_center_value, sum(case(community='Assiniboia',declared_construction_value,true,0)) as assiniboia_value, sum(case(community='Lord Selkirk/West Kildonan',declared_construction_value,true,0)) as west_kildonan_value, sum(case(community='East Kildonan/Transcona',declared_construction_value,true,0)) as east_kildonan_value, sum(case(community='Riel',declared_construction_value,true,0)) as riel_value, sum(declared_construction_value) as total_value&$where=issue_date between date_trunc_y('${endDate}') and '${endDate}'&$group=residential_category,building_type`
      );
      // By Residential Category
      const request07 = axios.get(
        `${this.$PERMIT_API}?$select=residential_category, sum(case(community='City Centre',declared_construction_value,true,0)) as city_center_value, sum(case(community='Assiniboia',declared_construction_value,true,0)) as assiniboia_value, sum(case(community='Lord Selkirk/West Kildonan',declared_construction_value,true,0)) as west_kildonan_value, sum(case(community='East Kildonan/Transcona',declared_construction_value,true,0)) as east_kildonan_value, sum(case(community='Riel',declared_construction_value,true,0)) as riel_value, sum(declared_construction_value) as total_value&$where=issue_date between date_trunc_y('${endDate}') and '${endDate}'&$group=residential_category`
      );
      // Total
      const request08 = axios.get(
        `${this.$PERMIT_API}?$select=sum(case(community='City Centre' and date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0)) as curr_city_center_value, sum(case(community='Assiniboia' and date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0)) as curr_assiniboia_value, sum(case(community='Lord Selkirk/West Kildonan' and date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0)) as curr_west_kildonan_value, sum(case(community='East Kildonan/Transcona' and date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0)) as curr_east_kildonan_value, sum(case(community='Riel' and date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0)) as curr_riel_value, sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0)) as curr_total_value, sum(case(community='City Centre' and date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0)) as prev_city_center_value, sum(case(community='Assiniboia' and date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0)) as prev_assiniboia_value, sum(case(community='Lord Selkirk/West Kildonan' and date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0)) as prev_west_kildonan_value, sum(case(community='East Kildonan/Transcona' and date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0)) as prev_east_kildonan_value, sum(case(community='Riel' and date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0)) as prev_riel_value, sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0)) as prev_total_value, round(100*(sum(case(community='City Centre' and date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0))/sum(case(community='City Centre' and date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0))-1),0) as city_centre_change_pct, round(100*(sum(case(community='Assiniboia' and date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0))/sum(case(community='Assiniboia' and date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0))-1),0) as assiniboia_change_pct, round(100*(sum(case(community='Lord Selkirk/West Kildonan' and date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0))/sum(case(community='Lord Selkirk/West Kildonan' and date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0))-1),0) as west_kildonan_change_pct, round(100*(sum(case(community='East Kildonan/Transcona' and date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0))/sum(case(community='East Kildonan/Transcona' and date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0))-1),0) as east_kildonan_change_pct, round(100*(sum(case(community='Riel' and date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0))/sum(case(community='Riel' and date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0))-1),0) as riel_change_pct, round(100*(sum(case(date_extract_y(issue_date)=date_extract_y('${endDate}'),declared_construction_value,true,0))/sum(case(date_extract_y(issue_date)=date_extract_y('${startDate}'),declared_construction_value,true,0))-1),0) as total_change_pct&$where=issue_date between date_trunc_y('${endDate}') and '${endDate}' or issue_date between date_trunc_y('${startDate}') and '${startDate}'`
      );

      const self = this;
      axios
        .all([
          request06,
          request07,
          request08,
        ])
        .then(
          axios.spread(function (
            response06,
            response07,
            response08,
          ) {
            self.response06 = response06.data;
            self.response07 = response07.data;
            self.response08 = response08.data;
          })
        );
    }
  },

  computed: {
    defaultBaseResidential() {
      return {
        assiniboia_value: "",
        city_center_value: "",
        west_kildonan_value: "",
        east_kildonan_value: "",
        riel_value: "",
        total_value: "",
      };
    },

    defaultTotal() {
      return {
        assiniboia_change_pct: "",
        city_centre_change_pct: "",
        curr_assiniboia_value: "",
        curr_city_center_value: "",
        curr_east_kildonan_value: "",
        curr_riel_value: "",
        curr_total_value: "",
        curr_west_kildonan_value: "",
        east_kildonan_change_pct: "",
        prev_assiniboia_value: "",
        prev_city_center_value: "",
        prev_east_kildonan_value: "",
        prev_riel_value: "",
        prev_total_value: "",
        prev_west_kildonan_value: "",
        riel_change_pct: "",
        total_change_pct: "",
        west_kildonan_change_pct: "",
      };
    },

    defaultTotalRes() {
      return {
        ...this.defaultBaseResidential,
        residential_category: "Residential",
      };
    },

    defaultTotalNonRes() {
      return {
        ...this.defaultBaseResidential,
        residential_category: "Non-Residential",
      };
    },

    residentials: function () {
      if (this.response06.length === 0) return [];
      return this.response06.filter(
        (res) => res.residential_category === "Residential"
      );
    },
    nonResidentials: function () {
      if (this.response06.length === 0) return [];
      return this.response06.filter(
        (res) => res.residential_category === "Non-Residential"
      );
    },
    totalRes: function () {
      if (this.response07.length === 0) return this.defaultTotalRes;
      const record = this.response07.find(
        (item) => item.residential_category === "Residential"
      );
      return record || this.defaultTotalRes;
    },
    totalNonRes: function () {
      if (this.response07.length === 0) return this.defaultTotalNonRes;
      const record = this.response07.find(
        (item) => item.residential_category === "Non-Residential"
      );
      return record || this.defaultTotalNonRes;
    },
    lastYear: function () {
      return parseInt(this.curYear) - 1;
    },
    total: function () {
      if (this.response08.length === 0) return this.defaultTotal;
      return this.response08[0];
    },
  },
};
</script>
